const state = {
    scheduleDetailDataList: [],
    scheduleDetailProductName: '',
};

export default state;